import { AlertOctagon, AlertTriangle, CheckCircle2 } from 'lucide-react';

export const ragPriority = { 'red': 0, 'amber': 1, 'green': 2 };

export const statusConfig = {
  red:   { label: 'Red',   color: 'bg-red-500',   textColor: 'text-red-700 dark:text-red-400',     bgLight: 'bg-red-50 dark:bg-red-900/20',    border: 'border-red-200 dark:border-red-800',     icon: AlertOctagon },
  amber: { label: 'Amber', color: 'bg-amber-500', textColor: 'text-amber-700 dark:text-amber-400', bgLight: 'bg-amber-50 dark:bg-amber-900/20', border: 'border-amber-200 dark:border-amber-800', icon: AlertTriangle },
  green: { label: 'Green', color: 'bg-green-500', textColor: 'text-green-700 dark:text-green-400', bgLight: 'bg-green-50 dark:bg-green-900/20', border: 'border-green-200 dark:border-green-800', icon: CheckCircle2 },
};
